/* eslint-disable consistent-return */
import { notification } from 'antd'
import { history } from 'index'
import Cookies from 'js-cookie'
import { handelError } from 'utils'
import apiClient from '../index'

export const getListOfEmployee = async (params, options = {}) => {
  const { silent = false } = options
  const {
    skip,
    limit,
    userRole,
    locationId,
    searchDepartment,
    searchProcess,
    userId,
    isActive,
    excludeAdmin,
    sortBy,
    sortOrder,
  } = params
  try {
    return await apiClient.get('employee', {
      params: {
        skip,
        limit,
        userRole,
        locationId,
        searchDepartment,
        searchProcess,
        userId,
        isActive,
        excludeAdmin,
        sortBy,
        sortOrder,
      },
      suppressErrorNotification: silent,
    })
  } catch (error) {
    if (!silent) {
      handelError(error)
    }
  }
}
export const getListOfAgent = async (params) => {
  const { status, skip, limit, employeeName } = params
  try {
    return await apiClient.get('employee/allAgents', {
      params: {
        status,
        skip,
        limit,
        employeeName,
      },
    })
  } catch (error) {
    handelError(error)
  }
}

export const getListofAgentHistory = async (params) => {
  const { skip, limit, userId, trainingType, status } = params
  try {
    return await apiClient.get('employee/agentHistory', {
      params: {
        skip,
        limit,
        userId,
        trainingType,
        status,
      },
    })
  } catch (error) {
    handelError(error)
  }
}
export const assignTrainer = async ({ id, userId }) => {
  try {
    return await apiClient.put(`employee/assignTrainer/${id}/${userId}`)
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
}
export const trainerDetailsUpdate = async ({ userId, trainerId }) => {
  try {
    return await apiClient.patch(`employee/updateTrainerDetails/${userId}/${trainerId}`)
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
}
export const agentsTrainerDetailsUpdate = async (data) => {
  try {
    return await apiClient.patch(`employee/updateTrainerDetails/multiple`, data)
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
}

export const filterEmployee = async (params) => {
  const { skip, limit, employeeName, locationId, depId, userProcess, userId } = params
  try {
    return await apiClient.get(`employee/filterEmployee`, {
      params: {
        skip,
        limit,
        employeeName,
        locationId,
        depId,
        userProcess,
        userId,
      },
    })
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
}

export const getTeamsEmpList = async ({ locationId, depId, includeAssigned = false }) => {
  try {
    return await apiClient.get(`employee/empListForTeam`, {
      params: {
        locationId,
        depId,
        includeAssigned,
      },
    })
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
}

export const updateEmployeeData = async (data) => {
  try {
    // This function reports its own failures below, so the response
    // interceptor's generic 4xx/5xx toast has to be turned off for this call --
    // otherwise a rejected update (a seat-limit refusal on reactivation, an
    // email conflict, ...) raises the identical notification twice.
    return await apiClient.patch('employee', data, { suppressErrorNotification: true })
  } catch (error) {
    if (error?.response?.data?.statusCode === 401) {
      Cookies.remove('accessToken')
      history.push('/auth/login')
    }
    // The interceptor is silenced for this call, so this is now the only
    // reporter -- a failure with no parsed body (a 5xx, a dropped connection)
    // has to raise something rather than fail quietly.
    notification.error({
      message: 'Error',
      description: error?.response?.data?.message || 'Unable to update employee. Please try again.',
    })
  }
}

export const updateEmployeeProfileImage = async ({ userId, userProfileImg }) => {
  try {
    return await apiClient.patch('employee/profileImage', { userId, userProfileImg })
  } catch (error) {
    if (error?.response?.data?.statusCode === 401) {
      Cookies.remove('accessToken')
      history.push('/auth/login')
    }
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
}

export const updateNewEmployeeData = async (data, userId) => {
  try {
    return await apiClient.patch(`employee/add-more-details/${userId}`, data)
  } catch (error) {
    if (error?.response?.data?.statusCode === 401) {
      Cookies.remove('accessToken')
      history.push('/auth/login')
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
}

export const updateAgentData = async (data) => {
  try {
    return await apiClient.patch('employee/updateAgent', data)
  } catch (error) {
    if (error?.response?.data?.statusCode === 401) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
}
export const updateMultipleAgentData = async (data) => {
  try {
    return await apiClient.patch('employee/updateMultipleAgent', data)
  } catch (error) {
    if (error?.response?.data?.statusCode === 401) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
}
export const updateAgentStatus = async (data) => {
  try {
    return await apiClient.patch('employee/updateAgentStatus', data)
  } catch (error) {
    if (error?.response?.data?.statusCode === 401) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
}
export const updateMultipleAgentsStatus = async (data) => {
  try {
    return await apiClient.patch('employee/updateMultipleAgentsStatus', data)
  } catch (error) {
    if (error?.response?.data?.statusCode === 401) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
}
export const deleteEmployee = async ({ userId, empId }) => {
  try {
    return await apiClient.delete(`employee/${userId}/${empId}`)
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
}
export const fetchNewEmpId = async (data = null, options = {}) => {
  const { silent = false } = options
  try {
    const params = data || undefined
    return await apiClient.get('employee/getNewEmpId', {
      params,
      suppressErrorNotification: silent,
    })
  } catch (error) {
    if (!silent && error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
}
export const addNewEmployee = async (empData, options = {}) => {
  const { silent = false } = options
  try {
    return await apiClient.post('employee', empData, {
      suppressErrorNotification: silent,
    })
  } catch (error) {
    if (!silent && error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
    // Caller (addEmpForm) reads addedEmp?.response?.data?.message when the
    // employee creation is rejected -- a seat-limit, an email/empId conflict,
    // or any other server-side validation failure. With silent:true this
    // function used to swallow `error` entirely and fall through to
    // `undefined`, so that message was never reachable and the form always
    // showed its generic fallback instead of the real reason. Returning the
    // error here is what makes that existing read actually work.
    if (silent) return error
  }
}
const normalizeCandidatePayload = (data = {}) => {
  const candidateBirthday = data?.candidateBirthday

  return {
    ...data,
    candidateBirthday:
      candidateBirthday && typeof candidateBirthday.format === 'function'
        ? candidateBirthday.format('YYYY-MM-DD')
        : candidateBirthday,
  }
}

export const addNewCandidate = async (Data) => {
  try {
    return await apiClient.post('/candidate', normalizeCandidatePayload(Data))
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
}
export const getCandidateList = async (params) => {
  // const { skip, limit, status, filterSkill, filterSkillLevel, grade } = params old code
  const { skip, limit, status, step, round } = params
  try {
    // return await apiClient.get(`candidate/candidateList`, { old code
    //   params: {
    //     skip,
    //     limit,
    //     status,
    //     filterSkill,
    //     filterSkillLevel,
    //     grade,
    //   },
    // })
    return await apiClient.get(`candidate/candidateList`, {
      params: {
        skip,
        limit,
        status,
        ...(round ? { round } : { step }),
      },
    })
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
}
export const updatedCandidateData = async (data) => {
  try {
    return await apiClient.patch('candidate/updateCandidate', normalizeCandidatePayload(data))
  } catch (error) {
    if (error?.response?.data?.statusCode === 401) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    } else if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
}

export const getSingleCandidate = async (userId) => {
  try {
    return await apiClient.get(`candidate/get-candidate?id=${userId}`)
  } catch (error) {
    if (error?.response?.status) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
  return null
}
export const updateCandidateStatus = async (candidateStepData) => {
  try {
    return await apiClient.post('candidate/candidate-step', candidateStepData)
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
  return null
}
export const bulkUpdateCandidateStatus = async (candidateStepData) => {
  try {
    return await apiClient.post('candidate/bulk-candidate-step', candidateStepData)
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
  return null
}
export const bulkCandidateStatus = async (candidateData) => {
  try {
    return await apiClient.post('candidate/bulk-candidate-status', candidateData)
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
  return null
}
export const directEmployeeOnboarding = async (candidateData) => {
  return apiClient.post('candidate/direct-employee-onboarding', candidateData, {
    suppressErrorNotification: true,
  })
}
export const getUserInfo = async ({ userId }) => {
  try {
    return await apiClient.get(`userInfo/${userId}`)
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
}
export const addResignation = async (data) => {
  try {
    return await apiClient.post('employee/addResignation', data)
  } catch (error) {
    if (error) {
      notification.error({
        message: error?.message,
      })
    }
  }
  return null
}
export const getListOfResignation = async (params) => {
  const { skip, limit, searchedEmp, status } = params
  try {
    return await apiClient.get('employee/getResignations', {
      params: {
        skip,
        limit,
        searchedEmp,
        status,
      },
    })
  } catch (error) {
    if (error) {
      notification.error({
        message: error?.message,
      })
    }
  }
  return null
}
export const deleteResignation = async (id, data) => {
  try {
    return await apiClient.patch(`employee/revokeResignation/${id}`, data)
  } catch (error) {
    if (error) {
      notification.error({
        message: error?.message,
      })
    }
  }
  return null
}
export const updateResignation = async (data, id) => {
  try {
    return await apiClient.patch(`employee/updateResignation/${id}`, data)
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
  return null
}

// export const uploadProfilePicture = async (empData) => {
//   try {
//     return await apiClient.post('media/image', empData)
//   } catch (error) {
//     if (error?.response?.data?.statusCode) {
//       notification.error({
//         message: 'Error',
//         description: error?.response?.data?.message,
//       })
//     }
//   }
// }

export const getEmployeeData = async ({ userId }) => {
  try {
    return await apiClient.get(`employee/data/${userId}`)
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
  return null
}

export const getTrainerList = (locationId) => {
  return apiClient.get('/employee/trainers', {
    params: {
      locationId,
    },
  })
}

export const getListOfEmployeeInDocument = async (params) => {
  const { skip, limit, searchEmployee, locationId, searchDepartment, searchProcess, status } =
    params
  try {
    return await apiClient.get('employee/allEmp', {
      params: {
        skip,
        limit,
        searchedEmployee: searchEmployee,
        locationId,
        depId: searchDepartment,
        processId: searchProcess,
        status,
      },
    })
  } catch (error) {
    handelError(error)
  }
}
export const getListOfEmpInDocument = async (params) => {
  const { locationId, searchDepartment, searchProcess, status } = params
  try {
    return await apiClient.get('employee/getAllEmpList', {
      params: {
        locationId,
        depId: searchDepartment,
        processId: searchProcess,
        status,
      },
    })
  } catch (error) {
    handelError(error)
  }
}
export const getListOfEmpInEmpMod = async (params) => {
  const { locationId, isActive } = params
  try {
    return await apiClient.get('employee/emp-filter', {
      params: {
        locationId,
        isActive,
      },
    })
  } catch (error) {
    handelError(error)
  }
}
